<template>
  <div>
    <span v-html="activityMessage"></span>
  </div>
</template>

<script>
export default {
  name: 'TablePermanentlyDeleted',
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    activityMessage() {
      const actor = this.activity?.actorUser?.name || 'Bilinmeyen Kullanıcı';
      const tableName = this.activity?.payload?.name || 'İsimsiz Tablo';
      
      return this.$t('notification.tablePermanentlyDeleted', {
        actor: `<strong>${actor}</strong>`,
        tableName: `<strong>${tableName}</strong>`
      });
    }
  }
};
</script>

<style scoped>
</style>

